import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { INVITE_LIST, INVITE_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: { create: request_state(), detail: request_state() },
    mutations: {
        ...request_mutations('create', 'create'),
        ...request_mutations('detail', 'detail'),
    },
    actions: {
        create({ commit }, { space_id, data }) {
            const url = INVITE_LIST.replace('{space_id}', space_id);

            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve();
                }).catch(error => commit('create_error', error.response ? error.response.data : {}));
            });
        },
        detail({ commit }, { key }) {
            commit('detail_loading');
            return new Promise((resolve) => {
                axios.get(INVITE_DETAIL.replace('{key}', key)).then((response) => {
                    commit('detail_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('detail_error', error.response ? error.response.data : {}));
            });
        },
    },
};
